import { LiveSubscriptionType } from "../../app/Subscriptions/types/LiveSubscriptionTypes.ts";
import { createGenericSlice, GenericActions, GenericState } from "../GenericSlice.ts";
import { PayloadAction } from "@reduxjs/toolkit";
import { Timestamp } from 'firebase/firestore';


type State = {
    data: LiveSubscriptionType[];
}

const initialState: State = {
    data: []
}

const LiveSubscriptionSlice = createGenericSlice({
    name: "LiveSubscriptionSlice",
    initialState: initialState as GenericState<LiveSubscriptionType[]>,
    reducers: {
        success: {
            reducer: (state, action: PayloadAction<LiveSubscriptionType[]>) => {
                state.data = action.payload;
                state.status = 'finished'
            },
            prepare: ({ data: Subscription, role }) => {


                Subscription = Subscription || []

                const LiveSubscriptionArray: LiveSubscriptionType[] = Subscription.map((data: any) => {

                    const billingStart = data.billingStart instanceof Timestamp
                        ? data.billingStart.toDate().toISOString()
                        : data.billingStart;
                    const startDate = data.startDate instanceof Timestamp
                        ? data.startDate.toDate().toISOString()
                        : data.startDate;
                    const billingEnd = data.billingEnd instanceof Timestamp
                        ? data.billingEnd.toDate().toISOString()
                        : data.billingEnd;

                    const lastOrderDate = data.lastOrderDate instanceof Timestamp
                        ? data.lastOrderDate.toDate().toISOString()
                        : data.lastOrderDate;

                    // Convert pauseHistory timestamps to ISO strings
                    const pauseHistory = data.pauseHistory || [];
                    const serializedPauseHistory = pauseHistory.map((item: any) => ({
                        pauseTS: item.pauseTS instanceof Timestamp
                            ? item.pauseTS.toDate().toISOString()
                            : item.pauseTS,
                        resumeTS: item.resumeTS instanceof Timestamp
                            ? item.resumeTS.toDate().toISOString()
                            : item.resumeTS
                    }));

                    return {
                        IsRecurringSubscription: data.IsRecurringSubscription,
                        billingType: data.billingType,
                        consumerId: data.consumerId,
                        cycle: data.cycle,
                        discountNegotiated: data.discountNegotiated,
                        email: data.email ? data.email : "",
                        name: data.name,
                        pauseCycleList: data.pauseCycleList ? data.pauseCycleList : [],
                        pauseCycleListIsNonEmpty: data.pauseCycleListIsNonEmpty ?? false,
                        pauseDaysLeft: data.pauseDaysLeft || 0,
                        phoneNumber: data.phoneNumber,
                        photoUrl: data.photoUrl,
                        priceMultiplier: data.priceMultiplier,
                        serviceType: data.serviceType,
                        status: data.status,
                        studentName: data.studentName,
                        subscriptionName: data.subscriptionName,
                        invoiceCycleList: data.invoiceCycleList,
                        id: data.id,
                        subscriptionPlanRefId: data.subscriptionPlanRef.id,
                        advance: data.advance,
                        products: data.products ? data.products : [{ name: "", price: 0 }],
                        Price: data.Price ? data.Price : 0,
                        secondaryMobile: data.secondaryMobile || "",
                        billingCycle: data.billingCycle || "",
                        billingStart,
                        billingEnd,
                        lastOrderStatus: data.lastOrderStatus || "",
                        lastOrderDate: lastOrderDate,
                        pauseHistory: serializedPauseHistory,
                        secondaryPayeeName: data.secondaryPayeeName || "",
                        secondaryEmail: data.secondaryEmail || "",
                        progress: data.progress || [],
                        remainingCount: data.remainingCount || 0,
                        subscriptionType: data.subscriptionType || "",
                        startDate: startDate,
                        assignedPlanIndex: data.assignedPlanIndex || 0,
                        assignedPlans: data.assignedPlans || [],
                        outsideState: data.outsideState ? data.outsideState : false,
                        consumerGSTIN: data.consumerGSTIN || "" ,
                        customerKYCResponses: data.customerKYCResponses || {},
                        excludeLiveSubFromGST: data.excludeLiveSubFromGST || false
                    }

                })

                const assignedSubscriptions = role?.assignedSubscriptions;
                const activeRole = role?.role;
                if (assignedSubscriptions && (activeRole === "Manager" || activeRole === "Observer")) {
                    const filteredSubscriptions = LiveSubscriptionArray.filter(subscription => assignedSubscriptions.includes(subscription.subscriptionPlanRefId));
                    return { payload: filteredSubscriptions }
                }

                return { payload: LiveSubscriptionArray }

            }
        },
        updateLiveSubscription: (state, action: PayloadAction<{ id: string, progress: any[] }>) => {
            const subscription = state.data.find(sub => sub.id === action.payload.id);
            if (subscription) {
                subscription.progress = action.payload.progress;
            }
        }
    }
})

export const { updateLiveSubscription } = LiveSubscriptionSlice.actions;
export const actions = LiveSubscriptionSlice.actions as GenericActions<LiveSubscriptionType[]>;
export default LiveSubscriptionSlice.reducer